import type { TBlindAreas } from '../../shared';

export const mergeBlindAreas = (
    defaultBlindAreas: TBlindAreas,
    dynamicBlindAreas: Partial<TBlindAreas> | null,
): TBlindAreas => ({
    ...defaultBlindAreas,
    ...dynamicBlindAreas,
});

export const isSameBlindAreas = (first: TBlindAreas, second: TBlindAreas) =>
    first.top === second.top &&
    first.right === second.right &&
    first.bottom === second.bottom &&
    first.left === second.left;
